module.exports = __webpack_public_path__ + "assets/img/small_otc_icon.e2c6424b.svg";